import styled from 'styled-components'
import {
  PiHandshakeLight,
  PiHandshakeFill,
  PiMagnifyingGlass,
  PiMagnifyingGlassFill,
  PiIdentificationCard,
  PiIdentificationCardFill,
  PiHouse,
  PiHouseFill,
  PiPlusCircle,
} from 'react-icons/pi'
import { Link, useLocation } from 'react-router-dom'
import { MobileNavItem } from '../Navbar/MobileSlideOutMenu'
import { useIsActive } from 'hooks/useIsActive'

import * as S from './Footer.styles'
import footerLogo from 'assets/Name - White Transparent.svg'
import { Z_INDEX } from 'styles/z-index'
import { MobileColors } from '../../../styles/mobileTokens'

const LogoIcon = styled.img`
  width: 100px;
`

type Props = {
  items: { label: string; to: string; onClick?: () => void }[]
}

const NavWrapper = styled.div`
  min-height: var(--footer-height);
  height: var(--footer-height);
`

const NavigationMenu = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  z-index: ${Z_INDEX.NAV};
  margin-right: auto;
  padding-left: 24px;
  gap: 24px;
`

const NavigationMenuItem = styled(Link)<{
  $isActive?: boolean
  $activeColor?: string
}>`
  font-weight: ${({ $isActive }) => ($isActive ? '500' : '300')};
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.05s ease-in-out;

  &:hover {
    background: rgb(44, 107, 78);
    text-decoration: none;
    color: #f2f4f7;
  }
`

function FooterNavMenu({ items }: Props) {
  const getIsActive = useIsActive()
  return (
    <NavigationMenu>
      {' '}
      {items.map(({ label, to, onClick }, i) => {
        return (
          <NavigationMenuItem
            $isActive={getIsActive(to)}
            $activeColor="#148552"
            to={to}
            replace={false}
            onClick={onClick || (() => {})}
            key={i}
          >
            {label}
          </NavigationMenuItem>
        )
      })}
    </NavigationMenu>
  )
}

export function MobileUnauthenticatedFooter() {
  const supportEmail = 'support@firstbite.io'
  const handleEmailClick = () => {
    window.open(`mailto:${supportEmail}`)
  }

  return (
    <NavWrapper className="bg-fb-dark-green">
      <div>
        <div className="flex justify-between">
          <FooterNavMenu
            items={[
              {
                label: 'Help',
                to: 'https://help.firstbite.io/',
              },
              {
                label: 'Privacy',
                to: '/privacy-policy',
              },
              {
                label: 'Terms',
                to: '/terms-of-use',
              },
              {
                label: 'Contact',
                to: '#',
                onClick: handleEmailClick,
              },
            ]}
          />
          <LogoIcon
            src={footerLogo}
            alt="logo"
            style={{
              marginRight: '10px',
            }}
          />
        </div>
      </div>
    </NavWrapper>
  )
}

const MobileFooterItem = styled(Link)<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  font-weight: 300;
  position: relative;
`

const SearchIconWrapper = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $isActive }) => ($isActive ? MobileColors.primary : 'inherit')};
`

const Span = styled.span`
  font-size: 12px;
`

const menuItems = [
  { icon: PiHouse, activeIcon: PiHouseFill, label: 'Home', to: '/' },
  {
    icon: PiHandshakeLight,
    activeIcon: PiHandshakeFill,
    label: 'Deals',
    to: '/deals',
  },
  {
    icon: PiIdentificationCard,
    activeIcon: PiIdentificationCardFill,
    label: 'Contacts',
    to: '/contacts',
  },
]

export function MobileFooter() {
  const getIsActive = useIsActive()
  const location = useLocation()

  // Check if on search page
  const isSearchActive = location.pathname === '/search'

  return (
    <S.MobileWrapper>
      <S.MobileContent>
        {/* nav items  */}
        {menuItems.map((item: MobileNavItem) => {
          // Don't show as active if search modal is open
          const isItemActive = !isSearchActive && getIsActive(item.to)
          return (
            <MobileFooterItem to={item.to} key={item.label}>
              {isItemActive ? <item.activeIcon /> : <item.icon />}
              <Span>{item.label}</Span>
            </MobileFooterItem>
          )
        })}

        {/* popup actions  */}
        <MobileFooterItem to="/search" $isActive={isSearchActive}>
          <SearchIconWrapper $isActive={isSearchActive}>
            {isSearchActive ? <PiMagnifyingGlassFill /> : <PiMagnifyingGlass />}
          </SearchIconWrapper>
          <Span>Search</Span>
        </MobileFooterItem>
        <MobileFooterItem to="#">
          <PiPlusCircle />
          <Span>Create</Span>
        </MobileFooterItem>
      </S.MobileContent>
    </S.MobileWrapper>
  )
}
